import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'nl2br',
  standalone: true,
})
export class Nl2BrPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string, sanitizeBeforehand?: boolean): string {
    if (typeof value !== 'string') {
      return value;
    }
    const textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br>');

    if (sanitizeBeforehand) {
      return this.sanitizer.sanitize(SecurityContext.HTML, textParsed) ?? '';
    }

    return textParsed;
  }
}
